import React, {Component, useEffect} from 'react'
import { withApollo } from 'react-apollo'
import PropTypes from 'prop-types'
import { Statistic, Typography, Spin, Row, Col, Input, message, Button, InputNumber, Radio, Form, Modal, Checkbox, Select } from 'antd'
import moment from 'moment'
import { Queries, Mutations } from '../../../graphql'
import { changeFormatdate } from '../../../utils/formatdate'
import { convertToHTMl } from '../../../utils/markDown'
import FormInputOTP from '../FormInputOTP'

const { Text, Title } = Typography
const { Option } = Select;
const { Countdown } = Statistic;

class FormInputAddress extends React.PureComponent {
    state = {
        dataAddress: [],
        dataProvince:[],
        dataAmphur: [],
        dataDistrict: [],
        idProvince:null,
        idAmphur:null,
		idDistrict :null,
        idPostalCode:null,
        // dataPostalCode: [],
        haveSMS: false,
		SMScode:"",
        checkBoxForm: true,
        disabledOTP:true,
        deadline: (Date.now()),
        otpToken: null,
        refCode: null,
        otpstate: true,
        labelCountAddress: '',
        labelCountGroupNo: '',
        labelCountBuilding: '',
        labelCountRoomNo: '',
        labelCountFloorNo: '',
        labelCountVilage: '',
        labelCountLane: '',
        labelCountStreet: '',
        modalShowMessage: false,
        loaddingSubmitModal: false
    }

    onChangePhoneNumber = async(e) =>{
        const { dataAddress } = this.state

        const reg = /^-?[0-9]*(\.[0-9]*)?$/;
        if ((!isNaN(e.target.value) && reg.test(e.target.value)) || e.target.value === '' || e.target.value === '-') {
    		dataAddress['phone1'] = e.target.value
        }
    }

    inputHtml = (inputType, disabled) =>{
       
        if(inputType == 'text' || inputType == 'email' ){
            return <Input 
                    className={ !disabled ? '' : 'font-italic' }
                    disabled={disabled}
                />
        }else if(inputType == 'number'){
            return <Input
                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                className={ !disabled ? '' : 'font-italic' } 
                disabled={disabled}
            />
        }
        else if(inputType == 'TextArea'){
            return <Input.TextArea
                className={ !disabled ? '' : 'font-italic' } 
                disabled={disabled}
            />
        }else if(inputType == 'phone'){
            return <Input
                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                className={ !disabled ? '' : 'font-italic' } 
                disabled={disabled}
                onChange={this.onChangePhoneNumber}
                maxLength={10}
            />
        }else if(inputType == 'otp'){
            return <Input
                disabled={disabled}
                maxLength={6}
            />
        }
            
    }

    formInput = (label, name, value, inputType, disabled, required, dataOptions = null) =>{
        const { getFieldDecorator } = this.props.form;
        return (
            <>
                <Col xs={24} sm={12} className="">
                    {
                        inputType == 'email' &&
                            <Form.Item label={label} style={{ marginBottom:"0px" }}>
                                { getFieldDecorator(name, {
                                    initialValue: value,
                                    rules:  [
                                        {
                                            type: 'email',
                                            message: 'กรุณากรอก'+label+'ให้ถูกต้อง',
                                            // required: true, 
                                        }
                                    ],
                                })(
                                    this.inputHtml(inputType, disabled)
                                )}
                            </Form.Item>
                        ||
                            <Form.Item label={label} style={{ marginBottom:"0px" }}>
                                { getFieldDecorator(name, {
                                    initialValue: value,
                                    rules:  [{ 
                                        required: required, 
                                        message: 'กรุณากรอก'+label,
                                    }],
                                })(
                                    this.inputHtml(inputType, disabled)
                                )}
                            </Form.Item>
                    }
                </Col>
            </>
        )
    }

    formSelect = (label, name, value, dataOptions, disabled, onChangeFilter) =>{
        const { getFieldDecorator } = this.props.form;
        return (
            <>
                <Col xs={24} sm={12} className="">
                    {
                        <Form.Item label={label} style={{ marginBottom:"0px" }}>
                            { getFieldDecorator(name, {
                                initialValue: value,
                                rules:  [
                                    { 
                                        required: true, 
                                        message: 'กรุณากรอกหรือเลือก '+label,
                                    }
                                ],
                            })(
                                <Select  style={{ width: "100%" }}  disabled={disabled} onChange={(e) => onChangeFilter(e, true)}>
                                    <Option value="">กรุณาเลือก </Option>
                                    {
                                        dataOptions.length !== 0 &&
                                        dataOptions.map((value, keys)=>
                                            <Option value={ value.id }>{ value.name } </Option>
                                        )
                                    }
                                </Select>
                            )}
                        </Form.Item>
                    }
                </Col>
            </>
        )
    }

    filterProvince = async (id = null, checkSelectForm) =>{
        const { client, location } = this.props
        const { dataAddress } = this.state
		const { data, errors } = await client.query({
			query: Queries.dropdownListProvince,
		})

		await this.setState({
            idProvince:id,
			dataProvince:data.dropdownListProvince
		})

        let checkIdSelect = data.dropdownListProvince.filter(data => data.id == id);

        if(checkIdSelect.length == 0){
            dataAddress['province'] = ''
            await this.props.form.setFieldsValue({
                province: '',
            })
            await this.setState({
                idProvince: null
            })
        }

        if(checkSelectForm){
			dataAddress['amphur'] = ''
			dataAddress['district'] = ''
            dataAddress['postalCode'] = ''
            this.props.form.setFieldsValue({
                amphur: '',
                district: '',
                postalCode:''
            })
            await this.filterAmphur()
            // await this.filterDistrict()
        }
    }

    filterAmphur = async (id = null, checkSelectForm) =>{
        const { idProvince, dataAddress } = this.state
		const { client, location } = this.props

        if(idProvince){
            const { data, errors } = await client.query({
                query: Queries.dropdownListAmphur,
                variables: {
                    id : idProvince
                }
            })
    
            if(data){
                let checkIdSelect = data.dropdownListAmphur.filter(data => data.id == id);
    
                if(checkIdSelect.length == 0){
                    dataAddress['amphur'] = ''
                    await this.props.form.setFieldsValue({
                        amphur: '',
                    })
                    await this.setState({
                        idAmphur: null
                    })
                }
    
                // console.log(data.dropdownListAmphur)
                await this.setState({
                    idAmphur:id,
                    dataAmphur:data.dropdownListAmphur
                })

                if(checkSelectForm){
                    dataAddress['district'] = ''
                    dataAddress['postalCode'] = ''
                    this.props.form.setFieldsValue({
                        district: '',
                        postalCode:''
                    })
                }
    
                if(id){
                    await this.filterDistrict()
                }
            }
        }else{
            dataAddress['amphur'] = ''
            await this.props.form.setFieldsValue({
                amphur: '',
            })
            await this.setState({
                idAmphur: null
            })
        }
    }

    filterDistrict = async (id = null) =>{
        const { idProvince, dataAddress, idAmphur } = this.state
		const { client, location } = this.props
        
        if(idAmphur){
            const { data, errors } = await client.query({
                query: Queries.dropdownListDistrict,
                variables: {
                    id : idAmphur
                }
            })
    
            if(data){
                let checkIdSelect = data.dropdownListDistrict.filter(data => data.id == id);
    
                if(checkIdSelect.length == 0){
                    dataAddress['idDistrict'] = ''
                    dataAddress['postalCode'] = ''
                    await this.props.form.setFieldsValue({
                        idDistrict:'',
                        postalCode: '',
                    })
                }
    
                data.dropdownListDistrict.filter(data => data.id == id).map(dataFilter => {
                    dataAddress['postalCode'] = dataFilter.postCode
                    this.props.form.setFieldsValue({
                        postalCode: dataFilter.postCode
                    })
                })
    
                await this.setState({
                    idDistrict:id,
                    dataDistrict:data.dropdownListDistrict,
                })
            
            }
    
        }else{
            dataAddress['district'] = ''
            dataAddress['postalCode'] = ''
            await this.props.form.setFieldsValue({
                district: '',
                postalCode: ''
            })
        }
    }

    onFinish = async () => {
        // console.log('finished!');
        await this.setState({ otpstate: true })
    }

    setSMS = async () => {
        const { client, location } = this.props
        const { dataAddress } = this.state

        const { data, errors } = await client.query({
            query: Queries.requestSendingOTP,
            variables: {
                telNo:dataAddress['phone1']
            }
        })

        this.setState({
            disabledOTP:false,
            otpstate:false,
            deadline: Date.now() + 1000 * (moment(data.requestSendingOTP.endTime).unix() -  moment(data.requestSendingOTP.startTime).unix()),
            otpToken: data.requestSendingOTP.otpToken,
            refCode: data.requestSendingOTP.refCode,
        })
	}

    createAddress = async (value) =>{
        const { swiptBoxShow } = this.props
    }

    updateAddress = async (value) =>{
        const { swiptBoxShow } = this.props

    }

    handleSubmit = async (e) => {
		const { form, handleSubmitDarf } = this.props
        const { otpToken, refCode, dataAddress } = this.state
        e.preventDefault()
		form.validateFields(async (err, values) => {
            if (!err) {
                values.addressName = dataAddress['addressName']
                values.addressNo = values.addressNo == '' ? ' ' : values.addressNo
                values.groupNo = values.groupNo == '' ? ' ' : values.groupNo
                values.building = values.building == '' ? ' ' : values.building
                values.roomNo = values.roomNo == '' ? ' ' : values.roomNo
                values.floorNo = values.floorNo == '' ? ' ' : values.floorNo
                values.vilage = values.vilage == '' ? ' ' : values.vilage
                values.lane = values.lane == '' ? ' ' : values.lane
                values.street = values.street == '' ? ' ' : values.street
                values.country = dataAddress['country']
                values.email1 = values.email1 == '' ? ' ' : values.email1
                values.phone1 = values.phone1 == '' ? ' ' : values.phone1

                // values.email1 = values.email1 == '' ? ' ' : values.email1
                // values.otp = {
                //     otpToken: otpToken,
                //     refCode: refCode,
                //     otpCode: values.otp
                // }

                window.scrollTo(0, 0)

                await this.setState({
                    modalShowMessage: true
                })
                
                setTimeout( async() => {
                    handleSubmitDarf(values)
				}, 3000);

            }
		})
	}

    checkEmailSend = (email) =>{
        var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);

        if (!pattern.test(email)) {
            message.error('กรุณากรอกอีเมลให้ถูกต้อง')
        }
    }

    onChangeCountInput = async(values ,numberLength, inputName) =>{
        if(values.length >= numberLength){
            if(inputName == 'addressNo'){
                await this.setState({
                    labelCountAddress: `<span style="color:red" class="pl-2">(จำนวนตัวอักษรครบกำหนด)</span>`
                })
            }else if(inputName == 'groupNo'){
                await this.setState({
                    labelCountGroupNo: `<span style="color:red" class="pl-2">(จำนวนตัวอักษรครบกำหนด)</span>`
                })
            }else if(inputName == 'building'){
                await this.setState({
                    labelCountBuilding: `<span style="color:red" class="pl-2">(จำนวนตัวอักษรครบกำหนด)</span>`
                })
            }else if(inputName == 'roomNo'){
                await this.setState({
                    labelCountRoomNo: `<span style="color:red" class="pl-2">(จำนวนตัวอักษรครบกำหนด)</span>`
                })
            }else if(inputName == 'floorNo'){
                await this.setState({
                    labelCountFloorNo: `<span style="color:red" class="pl-2">(จำนวนตัวอักษรครบกำหนด)</span>`
                })
            }else if(inputName == 'vilage'){
                await this.setState({
                    labelCountVilage: `<span style="color:red" class="pl-2">(จำนวนตัวอักษรครบกำหนด)</span>`
                })
            }else if(inputName == 'lane'){
                await this.setState({
                    labelCountLane: `<span style="color:red" class="pl-2">(จำนวนตัวอักษรครบกำหนด)</span>`
                })
            }else if(inputName == 'street'){
                await this.setState({
                    labelCountStreet: `<span style="color:red" class="pl-2">(จำนวนตัวอักษรครบกำหนด)</span>`
                })
            }
        }else{
            if(inputName == 'addressNo'){
                await this.setState({
                    labelCountAddress: ``
                })
            }else if(inputName == 'groupNo'){
                await this.setState({
                    labelCountGroupNo: ``
                })
            }else if(inputName == 'building'){
                await this.setState({
                    labelCountBuilding: ``
                })
            }else if(inputName == 'roomNo'){
                await this.setState({
                    labelCountRoomNo: ``
                })
            }else if(inputName == 'floorNo'){
                await this.setState({
                    labelCountFloorNo: ``
                })
            }else if(inputName == 'vilage'){
                await this.setState({
                    labelCountVilage: ``
                })
            }else if(inputName == 'lane'){
                await this.setState({
                    labelCountLane: ``
                })
            }else if(inputName == 'street'){
                await this.setState({
                    labelCountStreet: ``
                })
            }
        }
    }

    heideModal = async () =>{
        console.log('adfadfas')
        await this.setState({
            modalShowMessage: false,
            loaddingSubmitModal: true
        })
    }
    
    async componentDidMount(){
        const { dataAddressForm } = this.props
        await this.setState({
            dataAddress : dataAddressForm
        })
        console.log(dataAddressForm)
        await this.filterProvince(dataAddressForm['province'], false)
        await this.filterAmphur(dataAddressForm['amphur'], false)
        await this.filterDistrict(dataAddressForm['district'])
	}

    render() {
        const { getFieldDecorator } = this.props.form;
        const { 
            dataAddress, 
            dataProvince, 
            dataAmphur, 
            dataDistrict, 
            checkBoxForm, 
            disabledOTP, 
            otpstate, 
            labelCountAddress, 
            modalShowMessage, 
            loaddingSubmitModal,
            labelCountGroupNo,
            labelCountBuilding,
            labelCountRoomNo,
            labelCountFloorNo,
            labelCountVilage,
            labelCountLane,
            labelCountStreet,
        } = this.state
        // const { modalShowMessage } = this.props
        // console.log(dataAddress)
        return (
            <>
                <Modal
                    maskClosable={false}
                    title="แจ้งเตือน"
                    visible={modalShowMessage}
                    // onOk={ () => this.heideModal() }
                    onCancel={ () => this.heideModal()  }
                    footer={[
                        <Button key="submit" type="primary" className="color-white" onClick={() => this.heideModal()}>
                          รับทราบ
                        </Button>
                      ]}
                    >
                        <p>
                            ระบบใช้เวลา 1 ชั่วโมงในการอัพเดทข้อมูลของท่าน กรุณาตรวจสอบใหม่อีกครั้ง
                        </p>
                </Modal>
                {
                    !loaddingSubmitModal &&
                        <div>
                            {
                                dataAddress &&
                                
                                <Form onSubmit={this.handleSubmit}>
                                    <Row gutter={16} type="flex" align="top" >
                                            {/* { this.formInput(
                                                    'ชื่อที่อยู่', 
                                                    'addressName', 
                                                    dataAddress ? dataAddress['addressName'] ? dataAddress['addressName'] : '' : '', 
                                                    'text',
                                                    false,
                                                    false
                                                ) 
                                            } */}
            
                                            <Col xs={24} sm={12} className="">
                                                <Form.Item label={<div dangerouslySetInnerHTML={{ __html: 'เลขที่'+labelCountAddress }} style={{ display:"inline-block"  }}/>} style={{ marginBottom:"0px" }}>
                                                    { getFieldDecorator('addressNo', {
                                                        initialValue: dataAddress ? dataAddress['addressNo'] ? dataAddress['addressNo'] : '' : '',
                                                        rules:  [
                                                            {
                                                                // type: 'email',
                                                                message: 'กรุณากรอกเลขที่',
                                                                required: true, 
                                                            }
                                                        ],
                                                    })(
                                                        // this.inputHtml(inputType, disabled)
                                                        <Input 
                                                            className={ true ? '' : 'font-italic' }
                                                            onChange={ e => this.onChangeCountInput(e.target.value, 25, 'addressNo') }
                                                            disabled={false}
                                                            maxLength={25}
                                                        />
                                                    )}
                                                </Form.Item>
                                            </Col>

                                            <Col xs={24} sm={12} className="">
                                                <Form.Item label={<div dangerouslySetInnerHTML={{ __html: 'หมู่ที่'+labelCountGroupNo }} style={{ display:"inline-block"  }}/>} style={{ marginBottom:"0px" }}>
                                                    { getFieldDecorator('groupNo', {
                                                        initialValue: dataAddress ? dataAddress['groupNo'] ? dataAddress['groupNo'] : '' : '',
                                                    })(
                                                        // this.inputHtml(inputType, disabled)
                                                        <Input 
                                                            className={ true ? '' : 'font-italic' }
                                                            onChange={ e => this.onChangeCountInput(e.target.value, 25, 'groupNo') }
                                                            disabled={false}
                                                            maxLength={25}
                                                        />
                                                    )}
                                                </Form.Item>
                                            </Col>

                                            <Col xs={24} sm={12} className="">
                                                <Form.Item label={<div dangerouslySetInnerHTML={{ __html: 'อาคาร'+labelCountBuilding }} style={{ display:"inline-block"  }}/>} style={{ marginBottom:"0px" }}>
                                                    { getFieldDecorator('building', {
                                                        initialValue: dataAddress ? dataAddress['building'] ? dataAddress['building'] : '' : '',
                                                    })(
                                                        // this.inputHtml(inputType, disabled)
                                                        <Input 
                                                            className={ true ? '' : 'font-italic' }
                                                            onChange={ e => this.onChangeCountInput(e.target.value, 50, 'building') }
                                                            disabled={false}
                                                            maxLength={50}
                                                        />
                                                    )}
                                                </Form.Item>
                                            </Col>
                                            
                                            
                                            <Col xs={24} sm={12} className="">
                                                <Form.Item label={<div dangerouslySetInnerHTML={{ __html: 'เลขที่ห้อง'+labelCountRoomNo }} style={{ display:"inline-block"  }}/>} style={{ marginBottom:"0px" }}>
                                                    { getFieldDecorator('roomNo', {
                                                        initialValue: dataAddress ? dataAddress['roomNo'] ? dataAddress['roomNo'] : '' : '',
                                                    })(
                                                        // this.inputHtml(inputType, disabled)
                                                        <Input 
                                                            className={ true ? '' : 'font-italic' }
                                                            onChange={ e => this.onChangeCountInput(e.target.value, 25, 'roomNo') }
                                                            disabled={false}
                                                            maxLength={25}
                                                        />
                                                    )}
                                                </Form.Item>
                                            </Col>

                                            <Col xs={24} sm={12} className="">
                                                <Form.Item label={<div dangerouslySetInnerHTML={{ __html: 'ชั้นที่'+labelCountFloorNo }} style={{ display:"inline-block"  }}/>} style={{ marginBottom:"0px" }}>
                                                    { getFieldDecorator('floorNo', {
                                                        initialValue: dataAddress ? dataAddress['floorNo'] ? dataAddress['floorNo'] : '' : '',
                                                    })(
                                                        // this.inputHtml(inputType, disabled)
                                                        <Input 
                                                            className={ true ? '' : 'font-italic' }
                                                            onChange={ e => this.onChangeCountInput(e.target.value, 25, 'floorNo') }
                                                            disabled={false}
                                                            maxLength={25}
                                                        />
                                                    )}
                                                </Form.Item>
                                            </Col>

                                            <Col xs={24} sm={12} className="">
                                                <Form.Item label={<div dangerouslySetInnerHTML={{ __html: 'หมู่บ้าน'+labelCountVilage }} style={{ display:"inline-block"  }}/>} style={{ marginBottom:"0px" }}>
                                                    { getFieldDecorator('vilage', {
                                                        initialValue: dataAddress ? dataAddress['vilage'] ? dataAddress['vilage'] : '' : '',
                                                    })(
                                                        // this.inputHtml(inputType, disabled)
                                                        <Input 
                                                            className={ true ? '' : 'font-italic' }
                                                            onChange={ e => this.onChangeCountInput(e.target.value, 50, 'vilage') }
                                                            disabled={false}
                                                            maxLength={50}
                                                        />
                                                    )}
                                                </Form.Item>
                                            </Col>

                                            <Col xs={24} sm={12} className="">
                                                <Form.Item label={<div dangerouslySetInnerHTML={{ __html: 'ตรอกซอย/ซอย'+labelCountLane }} style={{ display:"inline-block"  }}/>} style={{ marginBottom:"0px" }}>
                                                    { getFieldDecorator('lane', {
                                                        initialValue: dataAddress ? dataAddress['lane'] ? dataAddress['lane'] : '' : '',
                                                    })(
                                                        // this.inputHtml(inputType, disabled)
                                                        <Input 
                                                            className={ true ? '' : 'font-italic' }
                                                            onChange={ e => this.onChangeCountInput(e.target.value, 50, 'lane') }
                                                            disabled={false}
                                                            maxLength={50}
                                                        />
                                                    )}
                                                </Form.Item>
                                            </Col>
                                            
                                            <Col xs={24} sm={12} className="">
                                                <Form.Item label={<div dangerouslySetInnerHTML={{ __html: 'ถนน'+labelCountStreet }} style={{ display:"inline-block"  }}/>} style={{ marginBottom:"0px" }}>
                                                    { getFieldDecorator('street', {
                                                        initialValue: dataAddress ? dataAddress['street'] ? dataAddress['street'] : '' : '',
                                                    })(
                                                        // this.inputHtml(inputType, disabled)
                                                        <Input 
                                                            className={ true ? '' : 'font-italic' }
                                                            onChange={ e => this.onChangeCountInput(e.target.value, 50, 'street') }
                                                            disabled={false}
                                                            maxLength={50}
                                                        />
                                                    )}
                                                </Form.Item>
                                            </Col>
                                            
                                            { this.formSelect(
                                                    'จังหวัด', 
                                                    'province', 
                                                    dataAddress ? dataAddress['province'] ? dataAddress['province'] : '' : '',
                                                    dataProvince,
                                                    false,
                                                    this.filterProvince
                                                ) 
                                            }
                                            
                                            { this.formSelect(
                                                    'อำเภอ/เขต', 
                                                    'amphur', 
                                                    dataAddress ? dataAddress['amphur'] ? dataAddress['amphur'] : '' : '',
                                                    dataAmphur,
                                                    false,
                                                    this.filterAmphur
                                                ) 
                                            }
                                            
                                            { this.formSelect(
                                                    'ตำบล/แขวง', 
                                                    'district', 
                                                    dataAddress ? dataAddress['district'] ? dataAddress['district'] : '' : '',
                                                    dataDistrict,
                                                    false,
                                                    this.filterDistrict
                                                ) 
                                            }
                                            
                                            { this.formInput(
                                                    'รหัสไปรษณีย์', 
                                                    'postalCode', 
                                                    dataAddress ? dataAddress['postalCode'] ? dataAddress['postalCode'] : '' : '',
                                                    'number',
                                                    true,
                                                    true
                                                ) 
                                            }
                                            
                                            {/* { this.formInput(
                                                    'ประเทศ', 
                                                    'country', 
                                                    dataAddress ? dataAddress['country'] ? dataAddress['country'] : '' : '',
                                                    'text',
                                                    false,
                                                    false
                                                ) 
                                            } */}
            
                                            <div style={{display:"none" }}>
                                                { this.formInput(
                                                        'โทรศัพท์ (มือถือ)', 
                                                        'phone1', 
                                                        dataAddress ? dataAddress['phone1'] ? dataAddress['phone1'] : '' : '',
                                                        'phone',
                                                        true,
                                                        false
                                                    )
                                                }
                                            </div>
                                            
                                            
                                            <div style={{display:"none" }}>
                                                { this.formInput(
                                                        'อีเมล', 
                                                        'email1', 
                                                        dataAddress ? dataAddress['email1'] !== ' ' ? dataAddress['email1'] : '' : '',
                                                        'email',
                                                        false,
                                                        true
                                                    ) 
                                                }
                                            </div>
                                            
                                            {/* { this.formInput(
                                                    'รหัสยืนยันตัวตนที่ได้จาก SMS', 
                                                    'otp', 
                                                    '',
                                                    // dataAddress ? dataAddress['phone1'] ? dataAddress['phone1'] : '' : '',
                                                    'otp',
                                                    disabledOTP,
                                                    true
                                                )
                                            } */}
            
                                            
                                            {/* <Col span={12} className="mt-4">
                                                <Row>
                                                    <Col span={24}>
                                                        <Button 
                                                            type="primary" 
                                                            disabled={ dataAddress['phone1'] ? (dataAddress['phone1'].length == 10 && otpstate) ? false : true : true } 
                                                            className="btn-link-page-custom-edit"
                                                            onClick={ this.setSMS }
                                                        >
                                                            ขอรหัสยืนยันตัวตน
                                                        </Button>
                                                    </Col>
                                                    <Col span={24}>
                                                        <Text className='color-gray' style={{ fontSize: "10px" }}>
                                                            สามารถกดขอใหม่ได้อีกครั้งใน : 
                                                            <Countdown className="mt-1 pl-2" valueStyle={{ fontSize: "10px" }} value={this.state.deadline} format="mm:ss" onFinish={this.onFinish} style={{ display:"inline-block"}} />
                                                        </Text>
                                                    </Col>
                                                </Row>
                                            
                                            </Col> */}
            
                                        {/* <Col xs={24} md={24} className="mt-3 mb-2">
                                            <strong>หมายเหตุ</strong>
                                            <p style={{ color:"#a2a2a2" }}>
                                                หากต้องการแก้ไขโทรศัพท์ (มือถือ) สามารถติดต่อขอปรับปรุงข้อมูลกับหน่วยงาน HR ต้นสังกัดของท่าน ดังนี้<br></br>
                                                - สำนักงานบริหารทรัพยากรบุคคล (สบค.) ติดต่อได้ที่งานฐานข้อมูลบุคลากร 0 2256 4058<br></br>
                                                - โรงพยาบาลจุฬาลงกรณ์ ติดต่อได้ที่ Call Center ของฝ่ายบริหารทรัพยากรบุคคล 0 2256 4000 ต่อ 4747<br></br>
                                                - โรงพยาบาลสมเด็จพระบรมราชเทวี ณ ศรีราชา ติดต่อได้ที่งานฐานข้อมูลบุคลากร 0 38320 200 ต่อ 3419<br></br>
                                            </p>
                                        </Col> */}
            
                                        <Col span={24} align="center" className="mt-4">
                                            <Button type="primary" className="btn-link-page-custom-edit" htmlType="submit">
                                                บันทึก
                                            </Button>
                                        </Col>
                                    </Row>
                                </Form>
                            }
                        </div>
                    ||
                        <div align="center">
                            <Spin />
                        </div>
                }
                
               
            </>
        )
    }
}

FormInputAddress.defaultProps = {
	autoFocus: false
}

FormInputAddress.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedFormInputAddress = Form.create()(FormInputAddress)

export default withApollo(WrappedFormInputAddress)